import { NavLink } from 'react-router-dom';
import { Theme, css } from '@emotion/react';

interface Props {
  exact?: boolean;
  text: string;
  to: string;
  hide?: boolean;
  variant?: 'primary' | 'secondary';
}

const clowncarMenuNavLinkRoot = ({ colors }: Theme) => css`
  color: ${colors.textLighter};
  &.is-active {
    color: ${colors.textWhite};
  }
`;

const ClowncarMenuNavLink: React.FunctionComponent<React.PropsWithChildren<Props>> = ({
  exact,
  text,
  to,
  hide,
  variant,
}) => {
  if (hide) {
    return null;
  }

  return (
    <NavLink
      css={variant === 'primary' && clowncarMenuNavLinkRoot}
      activeClassName="is-active"
      className={'ClowncarMenu-navLink'}
      exact={exact}
      to={to}
    >
      <span className="ClowncarMenu-navText" key="text">
        {text}
      </span>
    </NavLink>
  );
};

export default ClowncarMenuNavLink;
